import axios from "axios";

import authHeader from "./auth/auth-header";

const baseUrl = process.env.REACT_APP_API_URL;

const getInvoiceByFilters = async(params) => {

  const data = {
    dateStart: params.startDate ? params.startDate : null,
    dateEnd: params.endDate ? params.endDate : null,
    typeOfReceipt: params.typeOfReceipt ? params.typeOfReceipt : '',
    series: params.series ? params.series : '',
    an8: params.an8 ? params.an8 : '',

  };
  console.log(data)

  const token = await authHeader();

    const url = `${ baseUrl }/invoice-consultation/header`;
    return axios
      .get(url, {
        params: data,
        headers: token 
        }
      )
      .then(response => {
        return response.data;
       }
       )
  };

const getAdvancesDetail = async(params) => {

  const token = await authHeader();

    const url = `${ baseUrl }/invoice-consultation/detail-sales`;
    return axios
      .post(url, params,{
        headers: token 
        }
      )
      .then(response => {
        return response.data;
        }
        )
  };

const getInvoicesDetail = async(params) => {

  const token = await authHeader();

    const url = `${ baseUrl }/invoice-consultation/detail-discount`;
    return axios
      .post(url, params, {
        headers: token 
        }
      )
      .then(response => {
        return response.data;
        }
        )
  };

const getComplementsDetail = async(params, an8, advanceAmount, invoiceAmount) => {

  const token = await authHeader();

    const url = `${ baseUrl }/invoice-consultation/detail-anticipation/${an8}/${invoiceAmount}/${advanceAmount}`;
    return axios
      .post(url, params, {
        headers: token 
        }
      )
      .then(response => {
        return response.data;
        }
        )
  };

const downloadPaymentPdf = async (dataOrder, an8) => {
  const url = `${ baseUrl }/invoice-consultation/pdf/${an8}`;
  const token = await authHeader();

  return axios
    .post(url, dataOrder, {
      headers: token ,
      responseType: 'arraybuffer' 
    }
    )
    .then(response => {
      return response.data;
      }
      )
};

const downloadPaymentXml = async (dataOrder, an8) => {
  const url = `${ baseUrl }/invoice-consultation/xml/${an8}`;
  const token = await authHeader();

  return axios
    .post(url,dataOrder, {
      headers: token
    },
    {
      responseType: 'blob'
    }
    )
    .then(response => {
      return response.data;
      }
      )
};
const downloadAdvancesInvoiceConsultationXlsx = async (data, an8) =>{
  const token = await authHeader()
  const url = `${baseUrl}/invoice-consultation/excel/header/${an8}`
  return axios.post(url, data, {
    headers: token,
  }).then((response)=>{
    return response.data
  })

}

const downloadAdvancesInvoiceConsultationDetailXlsx = async (data, an8) =>{
  const token = await authHeader()
  const url = `${baseUrl}/invoice-consultation/excel/detail/${an8}`
  return axios.post(url, data, {
    headers: token,
  }).then((response) =>{
    return response.data
  })
}
const downloadPayment = async (data) => {

  console.log(data);

  const url = `${ baseUrl }/invoice/pdf-xml`;
  const token = await authHeader();

  return axios
  .get(url, {
    params: data,
    headers: token 
  },
  {
    responseType: 'blob'
  }
  )
  .then(response => {
    return response.data;
    }
    )
};

  export default {
    getInvoiceByFilters,
    getAdvancesDetail,
    getInvoicesDetail,
    getComplementsDetail,
    downloadPaymentPdf,
    downloadPaymentXml,
    downloadPayment,
    downloadAdvancesInvoiceConsultationXlsx,
    downloadAdvancesInvoiceConsultationDetailXlsx 
  }